import React from 'react';
import classnames from 'classnames';


// local dependencies
// import { getLabel } from 'modules/intl';
// import { LABEL_KEYS } from 'constants/intl';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 */
export const googleMap = React.forwardRef( ( props, forwardedRef ) => {

    // dynamic class names
    const widgetClassName = classnames( 'ui-google-map', props.className );

    return (
        <div className={ widgetClassName } ref={ forwardedRef }>
            <div className='ui-google-map__loading'>
                <div className='ui-google-map__loading__spinner'>
                    <div></div><div></div><div></div><div></div>
                </div>
            </div>
        </div>
    );
} );

// set display name
googleMap.displayName = 'googleMap';

// set default props
googleMap.defaultProps = {};

// prop types
googleMap.propTypes = {};
